import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_list",
  "use": "micro_list-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_list\"><path fill-rule=\"evenodd\" d=\"M0 2h10v1H0V2Zm0 3h10v1H0V5Zm0 3h10v1H0V8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol